module.exports = __webpack_public_path__ + "static/series_850-3d2bb353945435b42d1210723d9ad9de.png";